function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { MedicalRecordContext, ProfileContext } from 'context';
import { formatDate } from 'helpers/datetime';
import { useConversion, useStandards } from 'hooks';
import App from 'modules/App';
import messages from '../../../messages';
import styles from './Header.pcss';
const Header = ()=>{
    useStyles(styles);
    const intl = useIntl();
    const profileContext = useContext(ProfileContext);
    const medicalRecord = useContext(MedicalRecordContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const standards = useStandards();
    const conversion = useConversion('bloodGlucoseConcentration');
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.headerDailyLogReport,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: `${medicalRecord.firstName} ${medicalRecord.lastName}`
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: `${intl.formatMessage(messages.glucoseReport.diabetesType)}: ${App.messages.diabetesTypes[phiSet.diabetesType] ? `${intl.formatMessage(App.messages.diabetesTypes[phiSet.diabetesType])}` : '-'}`
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: `${intl.formatMessage(messages.glucoseReport.treatmentType)}: ${App.messages.treatmentTypes[phiSet.treatmentType] ? `${intl.formatMessage(App.messages.treatmentTypes[phiSet.treatmentType])}` : '-'}`
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: `${intl.formatMessage(messages.glucoseReport.dateOfBirth)}: ${medicalRecord.dateOfBirth ? formatDate(medicalRecord.dateOfBirth) : '-'}`
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: medicalRecord.email
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.headerLine
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.headerReportGenerated,
                            children: `${intl.formatMessage(messages.glucoseReport.generatedReport)}: ${formatDate(new Date())}`
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.headerDailyLogReport__title,
                    children: /*#__PURE__*/ _jsx("h1", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.title))
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: `${intl.formatMessage(messages.glucoseReport.criticalHigh)}: > ${conversion.toDisplay(standards.critical.highThreshold)} ${conversion.unitSymbol}`
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: `${intl.formatMessage(messages.glucoseReport.criticalLow)}: < ${conversion.toDisplay(standards.critical.lowThreshold)} ${conversion.unitSymbol}`
                        })
                    ]
                })
            ]
        })
    });
};
export default Header;
